import * as React from "react";
const SvgFiRrDogLeashed = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-dog-leashed_svg__a)">
      <path
        fill="#062147"
        d="M21.617 4.996a.8.8 0 0 1-.724-.447 2.79 2.79 0 0 0-2.513-1.553h-1.382V.766c0-.524-.522-.904-1.015-.726a3 3 0 0 0-1.985 2.824v1.8l-.964 2.67a1 1 0 0 1-.125.229L2.581.186a1 1 0 1 0-1.162 1.628l8.656 6.183-3.078.002c-1.087 0-2.087.36-2.908.952-.58-.261-2.09-1.115-2.09-2.955a1 1 0 0 0-2 0c0 2.487 1.613 3.847 2.706 4.485A4.94 4.94 0 0 0 2 13l.002 8.002A3 3 0 0 0 5.001 24 3.003 3.003 0 0 0 8 21V19l5-.003v2a3.004 3.004 0 0 0 3.005 3 3 3 0 0 0 2.999-3v-2.765c0-.418.044-.837.131-1.247l1.062-4.994a4.004 4.004 0 0 0 3.804-3.995v-.5c0-1.834-1.424-2.5-2.382-2.5zM6.998 17a1 1 0 0 0-1 1v3A1 1 0 0 1 4 21L3.998 13c0-1.654 1.345-3 2.998-3.001l4.002-.002v7L6.996 17zm10.004 1.23v2.767a1.001 1.001 0 0 1-2.004 0v-3.001a1 1 0 0 0-1-1h-.999V10.14l4.967 2.709-.791 3.72A8 8 0 0 0 17 18.232zm4.997-10.234c0 1.103-.897 2-2 2-.629 0-1.195.342-1.507.86l-3.943-2.15c.148-.212.276-.441.367-.692l1.089-3.018h2.375c.309 0 .586.17.724.447a2.79 2.79 0 0 0 2.512 1.553c.382 0 .382.363.382.5z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-dog-leashed_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDogLeashed;
